export var SalesOrderItemType;
(function (SalesOrderItemType) {
    SalesOrderItemType[SalesOrderItemType["SALE"] = 1] = "SALE";
    SalesOrderItemType[SalesOrderItemType["MISC_SALE"] = 2] = "MISC_SALE";
    SalesOrderItemType[SalesOrderItemType["DROP_SHIP"] = 3] = "DROP_SHIP";
    SalesOrderItemType[SalesOrderItemType["CREDIT_RETURN"] = 4] = "CREDIT_RETURN";
    SalesOrderItemType[SalesOrderItemType["DISCOUNT"] = 5] = "DISCOUNT";
    SalesOrderItemType[SalesOrderItemType["SUBTOTAL"] = 6] = "SUBTOTAL";
    SalesOrderItemType[SalesOrderItemType["ASSOC_PRICE"] = 7] = "ASSOC_PRICE";
    SalesOrderItemType[SalesOrderItemType["SHIPPING"] = 8] = "SHIPPING";
    SalesOrderItemType[SalesOrderItemType["TAX"] = 9] = "TAX";
    SalesOrderItemType[SalesOrderItemType["KIT"] = 10] = "KIT";
    SalesOrderItemType[SalesOrderItemType["NOTE"] = 11] = "NOTE";
    SalesOrderItemType[SalesOrderItemType["BOM_CONFIGURATION"] = 12] = "BOM_CONFIGURATION";
    // Ids match M5 reseed (20260729190000_firestore_migration_seeds): appended with no explicit
    // ids, continuing autoincrement past the 12 Fishbowl-default rows above.
    SalesOrderItemType[SalesOrderItemType["SAMPLE"] = 13] = "SAMPLE";
    SalesOrderItemType[SalesOrderItemType["PROMO"] = 14] = "PROMO";
})(SalesOrderItemType || (SalesOrderItemType = {}));
//# sourceMappingURL=sales-order-item-type.js.map